import React, { useState, useEffect, Fragment } from "react";
import axios from "../axios";
import { toast } from "react-toastify";
import { Row, Col, Spinner, Button, Form, Modal } from "react-bootstrap";
import Restricted from "../components/restricted";
import AjiltanItem from "../components/ajiltan-item/ajiltan-item";

const Ehlel = ({ logout }) => {
  const [employeeData, setEmployeeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);
  const [checkData, setCheckData] = useState(0);
  const [currentUser, setCurrentUser] = useState(null);
  const [editUser, setEditUser] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [showEditModal, setShowEditModal] = useState(false);

  const [myInputState, setMyInputState] = useState({
    email: "",
    password: "",
    name: "",
  });

  // Fetch current user
  useEffect(() => {
    const token = localStorage.getItem("salon");

    const fetchCurrentUser = async () => {
      try {
        const result = await axios.get("users/me", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCurrentUser(result.data.data);
      } catch (err) {
        console.error("Failed to fetch user:", err);
      }
    };

    if (token) {
      fetchCurrentUser();
    }
  }, []);

  const userAddHandler = async () => {
    const token = localStorage.getItem("salon");

    if (token) {
      setLoading(true);
      setError(null);
      try {
        await axios
          .post(
            "users/register",
            {
              name: myInputState.name,
              email: myInputState.email.toLowerCase(),
              password: myInputState.password,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then(() => {
            toast.success("Амжилттай");
            setCheckData(checkData + 1);
            setLoading(false);
          })
          .catch((err) => {
            toast.error(`Алдаа: ${err.response.data.error.message}`);
            setLoading(false);
          });
      } catch (error) {
        toast.error(`Алдаа: ${error}`);
      }
    }
  };

  const deleteUserHandler = async (userid) => {
    const token = localStorage.getItem("salon");

    if (token) {
      setLoading(true);
      setError(null);
      try {
        await axios
          .delete(`users/${userid}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then(() => {
            toast.success("Амжилттай");
            setCheckData(checkData + 1);
            setLoading(false);
          })
          .catch((err) => {
            toast.error(`Алдаа: ${err.response.data.error.message}`);
            setLoading(false);
          });
      } catch (error) {
        toast.error(`Алдаа: ${error}`);
      }
    }
  };

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const token = localStorage.getItem("salon");

        await axios
          .get("employees", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((result) => {
            setEmployeeData(result.data.data);
            setLoading(false);
          })
          .catch((err) => {
            toast.error(`Алдаа: ${err.response.data.error?.message}`);
            setLoading(false);
          });
      } catch (error) {
        toast.error(`Алдаа: ${error}`);
      }
    };

    if (localStorage.getItem("salon")) {
      setLoading(true);
      setError(null);

      fetchEmployeeData();
    }
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      const token = localStorage.getItem("salon");

      if (!token) {
        return;
      }

      setLoading(true);

      try {
        const result = await axios.get("users", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUsers(result.data.data);
      } catch (err) {
        console.log(
          `Алдаа: ${err.response?.data?.error?.message || err.message}`
        );
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [checkData]);

  const typingHandler = (e) => {
    const { name, value } = e.target;
    setError(null);
    setMyInputState({ ...myInputState, [name]: value });
  };

  const handleOpenEditModal = (user) => {
    setEditUser(user);
    setShowEditModal(true);
  };

  const updateUserHandler = async () => {
    const token = localStorage.getItem("salon");

    if (token) {
      setLoading(true);
      setError(null);
      try {
        await axios
          .patch(
            `users/${editUser._id}`,
            {
              name: editUser.name,
              email: editUser.email,
              password: editUser.password,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then(() => {
            toast.success("Амжилттай");
            setCheckData(checkData + 1);
            setLoading(false);
            setShowEditModal(false);
          })
          .catch((err) => {
            toast.error(`Алдаа: ${err.response.data.error.message}`);
            setLoading(false);
          });
      } catch (error) {
        toast.error(`Алдаа: ${error}`);
      }
    }
  };

  return (
    <div>
      {loading && (
        <div>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
      {localStorage.getItem("salon") ? (
        <Fragment>
          {/* Display user name */}
          {currentUser && (
            <div className="mb-4 p-3 bg-light rounded">
              <h5>
                Сайн байна уу, <strong>{currentUser.name}</strong>!
              </h5>
              <small className="text-muted">{currentUser.email}</small>
              {currentUser.role === "administrator" && (
                <span className="badge bg-primary ms-2">Админ</span>
              )}
            </div>
          )}

          {error && <div>{error}</div>}
          <Row md={3}>
            {employeeData.map((el) => (
              <Col key={el._id}>
                <a href={`/ajiltan/${el._id}/${el.name}`}>
                  <AjiltanItem name={el.name} />
                </a>
              </Col>
            ))}
          </Row>
          {/* <div className="col text-center">
            <Button className="mt-4 justify-center" onClick={logout}>
              Гарах
            </Button>
          </div> */}
          {/* Only show user management if admin */}
          {currentUser?.role === "administrator" && (
            <Row className="mt-5">
              <Col>
                <h4>Бүртгэлтэй хэрэглэгчид</h4>
                <div>
                  {users.map((el) => (
                    <Row
                      key={el.email}
                      className="shadow border mt-3 p-3 rounded registeredusers"
                    >
                      <Col className="item-user">
                        <div>
                          <div className="userName">{el.name}</div>
                          <div className="userEmail">{el.email}</div>
                        </div>
                        {el.role !== "administrator" && (
                          <div>
                            <Button
                              onClick={() => handleOpenEditModal(el)}
                              className="userEdit me-2"
                              variant="secondary"
                            >
                              Өөрчлөх
                            </Button>
                            <Button
                              onClick={() => {
                                deleteUserHandler(el._id);
                              }}
                              className="userDelete"
                              variant="danger"
                              disabled={1 >= users.length}
                            >
                              Устгах
                            </Button>
                          </div>
                        )}
                      </Col>
                    </Row>
                  ))}
                </div>
              </Col>
              <Col className="mb-5">
                <h4>Нэвтрэх эрх үүсгэх</h4>
                <Form>
                  <Form.Group className="mb-3 mt-3">
                    <Form.Control
                      type="text"
                      name="name"
                      onChange={typingHandler}
                      placeholder="Газрын нэр"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3 mt-3">
                    <Form.Control
                      type="email"
                      name="email"
                      onChange={typingHandler}
                      placeholder="И-мэйл хаяг"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="password"
                      name="password"
                      onChange={typingHandler}
                      placeholder="Нууц үг"
                    />
                  </Form.Group>
                  <Button
                    variant="primary"
                    className="float-right"
                    onClick={() => {
                      userAddHandler();
                    }}
                  >
                    Хэрэглэгч нэмэх
                  </Button>
                </Form>
              </Col>
            </Row>
          )}
          <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Хэрэглэгчийн мэдээлэл засах</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {/* Edit form fields go here */}
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Нэр</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Нэр"
                    value={editUser.name}
                    onChange={(e) =>
                      setEditUser({ ...editUser, name: e.target.value })
                    }
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>И-мэйл</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="И-мэйл"
                    value={editUser.email}
                    onChange={(e) =>
                      setEditUser({ ...editUser, email: e.target.value })
                    }
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Нууц үг</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Нууц үг"
                    value={editUser.password}
                    onChange={(e) =>
                      setEditUser({ ...editUser, password: e.target.value })
                    }
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowEditModal(false)}
              >
                Хаах
              </Button>
              <Button variant="primary" onClick={updateUserHandler}>
                Хадгалах
              </Button>
            </Modal.Footer>
          </Modal>
        </Fragment>
      ) : (
        <Restricted />
      )}
    </div>
  );
};

export default Ehlel;
